import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { TaxPayerService } from "src/app/services/taxPayer.service";
import { UserService } from "src/app/services/user.service";

@Component({
  selector: "app-vehicle-dialog",
  templateUrl: "./vehicle-dialog.component.html",
  styleUrls: ["./vehicle-dialog.component.css"],
})
export class VehicleDialogComponent implements OnInit {
  form: FormGroup;
  loading = false;
  currentUser: any;
  invalidTin = false;
  tinCheckInProgress = false;
  licenseCheckInProgress = false;
  isEdit = false;
  originalId: any;
  originalLicensePlate: string;
  constructor(
    private dialogRef: MatDialogRef<VehicleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private taxPayerService: TaxPayerService,
    public userService: UserService,
  ) {}

  async ngOnInit() {
    this.userService.getCurrentUser().subscribe(user => {
      this.currentUser = user;
    });

    this.form = this.fb.group({
      tin: [null, Validators.required],
      make: [null],
      model: [null],
      licensePlate: [null, Validators.required],
      chassisNumber: [null],
      municipalRegistry: [null],
    });

    if (this.data) {
      this.isEdit = true;
      this.originalId = this.data._id || this.data.id;
      this.originalLicensePlate = this.data.licensePlate;

      this.form.patchValue({
        tin: this.data.tin,
        make: this.data.vehicleMake,
        model: this.data.vehicleModel,
        licensePlate: this.data.licensePlate,
        chassisNumber: this.data.chassisNumber,
        municipalRegistry: this.data.municipalRegistry
      });
    }

    this.form.get('tin').valueChanges.subscribe(() => {
      const tinCtrl = this.form.get('tin');
      if (tinCtrl.hasError('tinNotFound')) {
        const errors = { ...(tinCtrl.errors || {}) };
        delete errors.tinNotFound;
        tinCtrl.setErrors(Object.keys(errors).length ? errors : null);
      }
    });

    this.form.get('licensePlate').valueChanges.subscribe(() => {
      const plateCtrl = this.form.get('licensePlate');
      if (plateCtrl.hasError('plateExists')) {
        const errors = { ...(plateCtrl.errors || {}) };
        delete errors.plateExists;
        plateCtrl.setErrors(Object.keys(errors).length ? errors : null);
      }
    });
  }

  save() {
    if (this.form.invalid || this.tinCheckInProgress || this.licenseCheckInProgress) return;
    this.invalidTin = false;
    this.tinCheckInProgress = true;
    const tin = this.form.value.tin;
    const licensePlate = this.form.value.licensePlate;

    this.taxPayerService.getTaxPayerByNiu('tax-payers', tin).subscribe({
      next: (company) => {
        this.tinCheckInProgress = false;

        if (!company || (!company.id && !company._id && !company.tin)) {
          this.invalidTin = true;
          const tinCtrl = this.form.get('tin');
          tinCtrl.setErrors({ ...(tinCtrl.errors || {}), tinNotFound: true });
          tinCtrl.markAsTouched();
          return;
        }

        const tinCtrl = this.form.get('tin');
        if (tinCtrl.hasError('tinNotFound')) {
          const errors = { ...(tinCtrl.errors || {}) };
          delete errors.tinNotFound;
          tinCtrl.setErrors(Object.keys(errors).length ? errors : null);
        }

        this.licenseCheckInProgress = true;

        this.taxPayerService.getVehicleByLicensePlate(licensePlate).subscribe({
          next: (vehicle) => {
            this.licenseCheckInProgress = false;

            let exists = false;

            if (Array.isArray(vehicle)) {
              exists = vehicle.some(v =>
                (v._id || v.id) && (v._id || v.id) !== this.originalId
              );
            } else if (vehicle) {
              const vid = vehicle._id || vehicle.id;
              exists = !!vid && vid !== this.originalId;
            }

            if (exists) {
              const plateCtrl = this.form.get('licensePlate');
              plateCtrl.setErrors({ ...(plateCtrl.errors || {}), plateExists: true });
              plateCtrl.markAsTouched();
              return;
            }

            this.loading = true;
            const payload: any = {
              tin: tin,
              companyName: company.name || company.companyName,
              municipalityId: company.municipality?.id || company.municipalityId,
              municipalityName: company.municipality?.name,
              vehicleMake: this.form.value.make,
              vehicleModel: this.form.value.model,
              licensePlate: this.form.value.licensePlate,
              chassisNumber: this.form.value.chassisNumber,
              municipalRegistry: this.form.value.municipalRegistry,
            };

            if (this.isEdit) {
              payload.id = this.originalId;
            }

            this.taxPayerService.saveVehicle(payload).subscribe({
              next: () => {
                this.loading = false;
                this.dialogRef.close({ reload: true });
              },
              error: () => {
                this.loading = false;
              }
            });
          },
          error: () => {
            this.licenseCheckInProgress = false;
            this.loading = true;
            const payload: any = {
              tin: tin,
              companyName: company.name || company.companyName,
              municipalityId: company.municipality?.id || company.municipalityId,
              municipalityName: company.municipality?.name,
              vehicleMake: this.form.value.make,
              vehicleModel: this.form.value.model,
              licensePlate: this.form.value.licensePlate,
              chassisNumber: this.form.value.chassisNumber,
              municipalRegistry: this.form.value.municipalRegistry,
            };

            if (this.isEdit) {
              payload.id = this.originalId;
            }

            this.taxPayerService.saveVehicle(payload).subscribe({
              next: () => {
                this.loading = false;
                this.dialogRef.close({ reload: true });
              },
              error: () => {
                this.loading = false;
              }
            });
          }
        });
      },
      error: () => {
        this.tinCheckInProgress = false;
        this.invalidTin = true;
        const tinCtrl = this.form.get('tin');
        tinCtrl.setErrors({ ...(tinCtrl.errors || {}), tinNotFound: true });
        tinCtrl.markAsTouched();
      }
    });
  }

  close() {
    this.dialogRef.close();
  }
}
